import { getSignedPatientPhotoUrl } from '@services/api/patient.api'
import React, { useEffect, useState } from 'react'
import defaultAvatar from '@assets/images/default_avatar.png'

type AvatarProps = {
  source: string
  width?: number
  height?: number
  className?: string
  style?: React.CSSProperties
  role?: string
  alt?: string
  name?: string
}

const Avatar = ({
  source,
  className,
  style,
  width,
  height,
  role,
  alt,
  name,
}: AvatarProps): React.ReactElement => {
  const [src, setSrc] = useState<string | null>(null)

  useEffect(() => {
    const resolvedSource = (source ?? '').trim()
    if (!resolvedSource) {
      setSrc(defaultAvatar)
      return
    }
    if (resolvedSource.includes('https://enamelai')) {
      getSignedPatientPhotoUrl(resolvedSource)
        .then((res) => setSrc(res.data.url))
        .catch(() => setSrc(defaultAvatar))
      return
    }
    if (resolvedSource.includes('https://cdn')) {
      setSrc(resolvedSource)
      return
    }
    if (resolvedSource.includes('\\tempstorage\\')) {
      const filename = resolvedSource.split(/[/\\]/).pop() ?? ''
      setSrc(`/tempstorage/${filename}`)
      return
    }
    setSrc(resolvedSource)
  }, [source])
  const handleImageError = (): void => {
    if (src && src !== defaultAvatar) {
      setSrc(defaultAvatar)
    }
  }

  return src ? (
    <img
      src={src}
      className={className}
      style={style}
      {...(width && { width })}
      {...(height && { height })}
      {...(role && { role })}
      alt={alt ?? (name ? `${name} avatar` : 'Avatar icon')}
      onError={handleImageError}
    />
  ) : (
    <></>
  )
}

export default Avatar
